<template>
  <div>
    <el-popover ref="popoverRef" placement="bottom" width="660" trigger="click">
      <div slot="reference" class="" @click="getList()">
        <vab-icon icon="arrow-up-down-line" />
        <span class="" style="cursor: pointer">标签同步</span>
        <el-badge
          v-if="headertTotal > 0"
          :value="headertTotal > 99 ? 99 + '+' : headertTotal"
        />
      </div>
      <div class="footer">
        <el-button
          size="mini"
          circle
          icon="el-icon-refresh"
          @click="getList()"
        />
      </div>
      <div style="height: 484px; overflow: auto">
        <el-table
          v-loading="tableLoading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.4)"
          :data="tableData"
          style="width: 100%"
        >
          <el-table-column prop="createTime" label="同步时间" width="160" />
          <el-table-column prop="fileName" label="同步至企业微信" width="">
            <template slot-scope="scope">
              <div>
                同步{{ scope.row.totalCount }}个{{ scope.row.taskName }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="同步状态" width="180">
            <template slot-scope="scope">
              <span v-if="scope.row.taskStatus == 0" style="color: #58d44d">
                同步中...
              </span>
              <span
                v-if="scope.row.taskStatus == 1 && scope.row.failCount == 0"
              >
                同步完成
              </span>
              <span
                v-if="scope.row.taskStatus == 1 && scope.row.failCount != 0"
              >
                同步完成：失败
                <span class="red">{{ scope.row.failCount }}</span>
                个
              </span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="50">
            <template slot-scope="scope">
              <el-button
                type="text"
                v-if="scope.row.taskStatus == 1 && scope.row.failCount > 0"
                @click="handleUpdata(scope.row)"
              >
                重推
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <el-pagination
        v-show="total > 0"
        class="mt10 mb10"
        style="text-align: right"
        background
        :page-sizes="[10, 20, 30, 50]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :pager-count="5"
        :size="queryParams.pageSize"
        :current-page="queryParams.pageNum"
        :auto-scroll="false"
        @current-change="handlePageChange"
        @size-change="handleSizeChange"
      />
    </el-popover>
  </div>
</template>

<script>
  import axios from 'axios'
  export default {
    name: 'VabTagSync',
    data() {
      return {
        messageShow: false,
        tableLoading: false,
        total: 0,
        headertTotal: 0,
        queryParams: {
          pageNum: 1,
          pageSize: 10,
        },
        tableData: [],

        // new websocket
        ws: null, //建立的连接
        lockReconnect: false, //是否真正建立连接
        timeout: 58 * 1000, //58秒一次心跳
        timeoutObj: null, //心跳心跳倒计时
        serverTimeoutObj: null, //心跳倒计时
        timeoutnum: null, //断开 重连倒计时
      }
    },
    created() {
      this.getList()
    },
    mounted() {},
    methods: {
      getpendingTaskCount() {},
      getList() {
        this.tableLoading = true
      },
      handlePageChange(val) {
        this.queryParams.pageNum = val
        this.getList()
      },
      handleSizeChange(val) {
        this.queryParams.pageSize = val
        this.queryParams.pageNum = 1
        this.getList()
      },
      handleUpdata() {},
      download(row) {
        let { filePath, fileName } = row
        this.$set(row, 'loading', true)
        axios
          .get(filePath, {
            responseType: 'blob',
            timeout: 120000,
          })
          .then((res) => {
            setTimeout(() => {
              // 延时一秒关闭加载动画
              this.$set(row, 'loading', false)
            }, 1000)

            let url = window.URL.createObjectURL(new Blob([res.data]))
            let link = document.createElement('a')
            link.style.display = 'none'
            link.href = url
            link.setAttribute('download', fileName)
            document.body.appendChild(link)

            link.click()
            this.$refs.popoverRef.doShow()
          })
      },
    },
  }
</script>

<style lang="scss" scoped>
  :deep() {
    .el-tabs__active-bar {
      min-width: 28px;
    }
  }

  .content {
    position: relative;
    font-size: 14px;
    .handleText {
      cursor: pointer;
      position: relative;
    }
  }
  .redNum {
    color: #fff;
    background: red;
    border-radius: 50%;
    position: absolute;
    width: 14px;
    height: 14px;
    line-height: 14px;
    text-align: center;
    font-size: 12px;
    top: 8px;
    right: -10px;
  }
  .messageList {
    background: #fff;
    top: 52px;
    right: 0;
    z-index: 999;

    .messageFooter {
      cursor: pointer;
      background: #eee;
      width: 100%;
      height: 44px;
      line-height: 44px;
      text-align: center;
      position: absolute;
      bottom: -40px;
    }
    .messageList-item {
      height: 44px;
      line-height: 44px;
      padding-left: 10px;
      border-bottom: 1px solid #eee;
      display: flex;
      align-items: center;
      .messageList-item-name {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 380px;
      }
      .messageList-item-download {
        color: #1890ff;
      }
      .messageList-item-download {
        font-size: 16px;
        font-weight: bold;
        cursor: pointer;
      }
    }
  }
  .messageList-item-download {
    color: #1890ff;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
  }

  .footer {
    width: 100%;
    cursor: pointer;
    text-align: right;
    margin-bottom: 10px;
  }
</style>
